import { Component, OnInit } from "@angular/core";
import { TemplateType } from "../../../../shared/Models/enums/TemplateType.enum";
import { TemplateLanguage } from "../../../../shared/Models/enums/TemplateLanguage.enum";
import { NetworkOwnerService } from "src/app/shared/services/network-owner.service";
import { TemplateService } from "../../services/template.service";
import { first } from "rxjs/operators";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-create-template",
  templateUrl: "./create-template.component.html",
  styleUrls: ["./create-template.component.scss"],
})
export class CreateTemplateComponent implements OnInit {
  types = [
    {
      label: TemplateType[TemplateType.SSR],
      value: TemplateType.SSR,
    },
    {
      label: TemplateType[TemplateType.TSA],
      value: TemplateType.TSA,
    },
    {
      label: TemplateType[TemplateType.TSANOADMIN],
      value: TemplateType.TSANOADMIN,
    },
  ];
  languages = [
    {
      label: TemplateLanguage[TemplateLanguage.nl].toUpperCase(),
      value: TemplateLanguage.nl,
    },
    {
      label: TemplateLanguage[TemplateLanguage.fr].toUpperCase(),
      value: TemplateLanguage.fr,
    },
    {
      label: TemplateLanguage[TemplateLanguage.de].toUpperCase(),
      value: TemplateLanguage.de,
    },
  ];
  networkOwners = [];

  type: TemplateType = null;
  language: TemplateLanguage = null;
  networkOwnerId: string = null;
  filename: string;
  file: any = null;

  constructor(
    private networkOwnerService: NetworkOwnerService,
    private templateService: TemplateService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.networkOwnerService
      .getNetworkOwners()
      .pipe(first())
      .subscribe(
        (res) =>
          (this.networkOwners = res.map((x) => ({
            label: x.name,
            value: x.id,
          })))
      );
  }

  onSave(): void {
    this.templateService
      .createTemplate(this.type, this.language, this.networkOwnerId, this.file)
      .then((_) => this.router.navigate(["admin/templates"]));
  }

  onFileSelected(e: any): void {
    const file = e.target.files[0];
    this.filename = file.name;
    this.file = file;
  }

  canSave() {
    return (
      this.type !== null &&
      this.language !== null &&
      this.networkOwnerId !== null &&
      this.file !== null
    );
  }
}
